import { useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import { cargoApi } from '@/api/cargo';
import { fmt } from '@/shared/format';
import { PageHead } from '@/shared/ui/kit';
import { SHIPMENT_STATUS_COLOR } from '@/shared/cargo';

function Kpi({ icon, label, value, color }: { icon: string; label: string; value: string | number; color?: string }) {
  return (
    <div className="ts-card cg-kpi">
      <div className="ts-flex-row" style={{ justifyContent: 'space-between' }}>
        <div>
          <div className="cg-kpi-val" style={{ color: color ?? 'var(--ts-text)' }}>{value}</div>
          <div className="cg-kpi-lbl">{label}</div>
        </div>
        <i className={`bi ${icon}`} style={{ fontSize: '1.8rem', color: color ?? 'var(--ts-brand)', opacity: 0.7 }} />
      </div>
    </div>
  );
}

export function DashboardPage() {
  // Карго company анх ажиллахад default агуулах + тариф seed.
  useEffect(() => {
    cargoApi.ensureDefaults().catch(() => {});
  }, []);

  const q = useQuery({ queryKey: ['cargo', 'dashboard'], queryFn: cargoApi.dashboard });
  const d = q.data;

  return (
    <div>
      <PageHead title="Хянах самбар" subtitle="Өнөөдрийн карго үйл ажиллагааны тойм." />
      <div className="ts-row" style={{ marginBottom: 16 }}>
        <div style={{ gridColumn: 'span 3' }}><Kpi icon="bi-box-arrow-in-down" label="Өнөөдөр хүлээн авсан" value={d?.ReceivedToday ?? 0} /></div>
        <div style={{ gridColumn: 'span 3' }}><Kpi icon="bi-truck" label="Замд яваа" value={d?.InTransit ?? 0} color="var(--ts-high)" /></div>
        <div style={{ gridColumn: 'span 3' }}><Kpi icon="bi-bell" label="Очиж авахад бэлэн" value={d?.ReadyForPickup ?? 0} color="var(--ts-warn)" /></div>
        <div style={{ gridColumn: 'span 3' }}><Kpi icon="bi-exclamation-circle" label="Хүргэгдээгүй" value={d?.Undelivered ?? 0} color="var(--ts-critical)" /></div>
        <div style={{ gridColumn: 'span 6' }}><Kpi icon="bi-cash-stack" label="Төлөгдсөн орлого" value={fmt(d?.RevenuePaid ?? 0)} color="var(--ts-ok)" /></div>
        <div style={{ gridColumn: 'span 6' }}><Kpi icon="bi-hourglass-split" label="Төлөгдөөгүй дүн" value={fmt(d?.RevenueUnpaid ?? 0)} color="var(--ts-warn)" /></div>
      </div>

      <div className="ts-card">
        <div className="if-card-head"><i className="bi bi-bar-chart" /><span>Төлвөөр</span></div>
        <div className="if-card-body" style={{ display: 'flex', flexWrap: 'wrap', gap: 12 }}>
          {(d?.ByStatus ?? []).map((s) => (
            <div
              key={s.Status}
              className="ts-card"
              style={{ padding: '10px 16px', minWidth: 150, borderLeft: `4px solid ${SHIPMENT_STATUS_COLOR[s.Status]}` }}
            >
              <div style={{ fontSize: '1.4rem', fontWeight: 800 }}>{s.Count}</div>
              <div className="cg-kpi-lbl">{s.StatusLabel}</div>
            </div>
          ))}
          {d && !d.ByStatus.length && <div className="ts-page-sub">Илгээмж бүртгэгдээгүй байна.</div>}
        </div>
      </div>
    </div>
  );
}
